import { useQuery } from '@tanstack/react-query';
import { fetchActiveProjects, fetchProjects } from '../../api/mel/projects/projects';

export const PROJECT_STATUSES = [
  'identification',
  'implementation',
  'completion',
  'post_completion',
  'cancelled',
  'suspended',
];

export const useProjects = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['projects', filters],
    queryFn: () => fetchProjects(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    projects: query.data?.data?.projects ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export const useActiveProjects = (options = {}) => {
  const query = useQuery({
    queryKey: ['projects', 'active'],
    queryFn: fetchActiveProjects,
    enabled: options.enabled ?? true,
    
  });

  return {
    ...query,
    projects: query.data?.data?.projects ?? [],
  };
};

export default useProjects;
